import React, { useContext } from 'react';

import { useChildComponent } from '@gogame/hooks-ts';
import DataGrid from '@gogame/data-grid';
import { useScreenTitle } from '@gogame/screens';
import { Tags } from '@gogame/components';

import { SCOPE_CONCEPT_FAMILIES } from 'scenes/Gallery/GalleryPage/constants';
import ConceptFamilyActions from 'scenes/Gallery/GalleryPage/ConceptFamilies/Actions';
import * as CONCEPT_FAMILY from 'scenes/Gallery/GalleryPage/ConceptFamilies/view-constants';

import { DetailsColumn, PreviewColumn } from './Columns';
import ConceptFamiliesDataTableContext from './ConceptFamiliesDataTableContext';
import { BatchToolbarDataGrid } from './components/BatchToolbar';
import Toolbar from './components/Toolbar';
import {
  COLUMN_ID,
  COLUMN_PREVIEW,
  COLUMN_DETAILS,
  COLUMN_TAGS,
  COLUMN_CREATED_BY,
  COLUMN_CREATED_DATE,
  COLUMN_UPDATED_DATE,
} from './constants';

const ConceptFamiliesDataTable = ({ tabs, height }) => {
  const {
    data,
    isLoading,
    isRefetching,
    tableSettings,
    columns,
    onReorder,
    onCollapse,
    onChangeSettings,
  } = useContext(ConceptFamiliesDataTableContext);

  const [screenTitle] = useScreenTitle();

  const [childComponent, openChildComponent] = useChildComponent();

  return (
    <React.Fragment>
      <DataGrid
        rows={data?.rows}
        count={data?.count}
        title={screenTitle}
        loading={isLoading}
        fetching={isRefetching}
        onChangeSettings={onChangeSettings}
        onReorder={onReorder}
        onCollapse={onCollapse}
        tableSettings={tableSettings}
        columnsState={columns}
        checkboxSelection={true}
        toolbar={<Toolbar tabs={tabs} />}
        selectedRowsToolbarActions={({ selectedValues }) => (
          <BatchToolbarDataGrid
            selectedValues={selectedValues}
            openChildComponent={openChildComponent}
          />
        )}
        storageKey={SCOPE_CONCEPT_FAMILIES}
        defaultColumnWidth={120}
        rowHeight={80}
        minHeight={height}
        notInitedLabel={'No records'}
      >
        <DataGrid.Column
          field={COLUMN_ID}
          type={'text'}
          headerName={'ID'}
          width={90}
          fixed={true}
          resizable={false}
          align={'right'}
          headerAlign={'right'}
        />
        <DataGrid.Column
          field={COLUMN_PREVIEW}
          headerName={'Preview'}
          width={130}
          fixed={true}
          resizable={false}
          sortable={false}
          formatter={(_, row) => <PreviewColumn row={row} />}
        />
        <DataGrid.Column
          field={COLUMN_DETAILS}
          headerName={'Details'}
          width={800}
          sortable={false}
          formatter={(_, row) => <DetailsColumn row={row} />}
        />
        <DataGrid.Column
          field={COLUMN_TAGS}
          headerName={'Internal Tags'}
          width={300}
          sortable={false}
          formatter={(_, row, { width }) => {
            const { [CONCEPT_FAMILY.INTERNAL_TAGS]: tags } = row;

            if (tags?.length) {
              return <Tags data={tags} width={width} lineClamp={2} />;
            }
          }}
        />
        <DataGrid.Column
          field={COLUMN_UPDATED_DATE}
          headerName={'Last Updated'}
          type={'date'}
          width={135}
          timeZone={'local'}
          template={'LLL'}
        />
        <DataGrid.Column
          field={COLUMN_CREATED_BY}
          headerName={'Created by'}
          type={'text'}
          width={150}
          formatter={(_, row) => row[CONCEPT_FAMILY.CREATED_BY]}
        />
        <DataGrid.Column
          field={COLUMN_CREATED_DATE}
          headerName={'Created'}
          type={'date'}
          width={150}
          timeZone={'local'}
          template={'LLL'}
        />
        <DataGrid.Column
          actionsColDef
          type={'actions'}
          onOpenChildComponent={openChildComponent}
          actionsComponent={ConceptFamilyActions}
          limit={2}
        />
      </DataGrid>
      {childComponent}
    </React.Fragment>
  );
};
export default ConceptFamiliesDataTable;
